import { ExternalStyles, HFlow, Icon, Text } from 'bold-ui'
import { orange } from 'bold-ui/lib/styles/colors'
import { CriticidadeAlergia } from 'graphql/types.generated'

interface AlergiaPrincipioAtivoAlertProps {
  hSpacing?: number
  style?: ExternalStyles
  criticidade?: CriticidadeAlergia
}

export function AlergiaPrincipioAtivoAlert(props: Readonly<AlergiaPrincipioAtivoAlertProps>) {
  const { hSpacing = 0.25, style, criticidade } = props

  const criticidadeFormatada =
    !criticidade || criticidade === CriticidadeAlergia.NAO_INFORMADA ? 'indeterminada' : criticidade.toLowerCase()

  return (
    <HFlow hSpacing={hSpacing} alignItems='center' style={style}>
      <Icon color={orange.c40} icon='exclamationTriangleOutline' size={1} />
      <Text color='alert'>Alergia ao princípio ativo {criticidade ? `(Criticidade ${criticidadeFormatada})` : ''}</Text>
    </HFlow>
  )
}
